import { Col, Row } from 'react-bootstrap';
import PopoverTemplate from '@nkr/components/popover-template';
import styled from 'styled-components';

const PopoverWrapper = styled(PopoverTemplate) <{ width?: string }>`
    max-width: ${p => p.width ? p.width : '600px'};
    
    & > div {
        font-size: 12px;
    }
`;

const informationOverlay = (
    <PopoverWrapper title={<h4>Guide to ILDA</h4>}>
        <div>
            <h5 style={{ fontSize: 16 }}>Tab Information</h5>

            <Row style={{ marginBottom: 10 }}>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>UNASSIGNED</Col>
                <Col xs={12} lg={9}>All tickets where the counselor has not yet been assigned and the next follow-up date is in the next 7 days </Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>TO DO</Col>
                <Col xs={12} lg={9}>All tickets that are assigned to the current user and not closed or the next follow-up date is empty or has already passed</Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>ASSIGNED TO ME</Col>
                <Col xs={12} lg={9}>All tickets assigned to the current user that are not closed</Col>
            </Row>

            <Row style={{ marginBottom: 20 }}>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>ALL</Col>
                <Col xs={12} lg={9}>All tickets regardless of status or next follow-up date</Col>
            </Row>

            <h5 style={{ fontSize: 16 }}>Additional Information</h5>

            <Row style={{ marginBottom: 10 }}>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>Next Follow-Up Date</Col>
                <Col xs={12} lg={9}>
                    <div>This is one of the following:</div>
                    <ul>
                        <li>The next follow-up date if set, or</li>
                        <li>Two (2) days after the donor opted-in to Ilda, or</li>
                        <li>Two (2) days from the current date</li>
                    </ul>
                </Col>
            </Row>

            <Row>
                <Col xs={12} lg={3} style={{ fontWeight: 600 }}>Assigned Counselor</Col>
                <Col xs={12} lg={9}>
                    <div>The numbers after the name in the list are:</div>
                    <div style={{ paddingLeft: 30 }}>CURRENT ACTIVE CASES / CASE LOAD LIMIT</div>
                </Col>
            </Row>
        </div>
    </PopoverWrapper>
);

export default informationOverlay;